/*
 * External URLs the app links to. bpanel.dev is the marketing site (home, pricing and contact are live).
 * Terms, privacy, docs and status are PLACEHOLDERS: agreed paths for pages that do not exist yet. Every link
 * to one is marked with <SoonBadge /> (or the `common:placeholder.*` copy) until the page is published; then
 * remove its key from PLACEHOLDER_PAGES and the badges go with it.
 */
import type { Locale } from '@/i18n/locale'

export const marketingUrl = 'https://bpanel.dev'

const prefix = (locale: Locale) => (locale === 'en' ? '/en' : '')

export const siteLinks = {
  home: (l: Locale) => `${marketingUrl}${prefix(l)}/`,
  pricing: (l: Locale) => `${marketingUrl}${prefix(l)}/pricing/`,
  contact: (l: Locale) => `${marketingUrl}${prefix(l)}/contact/`,
  terms: (l: Locale) => `${marketingUrl}${prefix(l)}/terms/`,
  privacy: (l: Locale) => `${marketingUrl}${prefix(l)}/privacy/`,
  docs: (l: Locale) => `${marketingUrl}${prefix(l)}/docs/`,
  status: () => 'https://status.bpanel.dev',
}

export type SitePage = keyof typeof siteLinks
export const PLACEHOLDER_PAGES: ReadonlySet<SitePage> = new Set<SitePage>(['terms', 'privacy', 'docs', 'status'])
export const isPlaceholder = (page: SitePage) => PLACEHOLDER_PAGES.has(page)

/** APT repository and installer (plan/11-packaging-distribution.md). */
export const install = {
  aptRepo: 'https://apt.bpanel.dev',
  installer: 'bpanel-install',
  installerPackage: 'bpanel-installer',
  /** the panel's port on the server (`https://HOST:8443`) */
  panelPort: 8443,
  /** the first admin's one-time sign-in link the installer prints lasts this long */
  adminLinkHours: 72,
  supportedOs: ['debian-12', 'ubuntu-22.04', 'ubuntu-24.04'] as const,
}
